var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',[_c('SumarioFormRobados',{attrs:{"formType":this.formType,"viewData":this.viewData,"actuacionType":this.actuacionType},on:{"onSave":_vm.onSave}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }